<template>
    <div>
        <v-container>
            <v-toolbar dense flat color="transparent">
                <v-toolbar-title class="font-weight-bold"
                    >Event Details</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn @click="onDelete()" color="error" text class="ml-2"
                    >Delete</v-btn
                >
                <v-btn @click="onSave()" color="primary" class="ml-2"
                    >Save</v-btn
                >
            </v-toolbar>
            <v-row>
                <v-col cols="4">
                    <v-form ref="editForm">
                        <v-card flat>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">Name</div>
                                <v-text-field
                                    v-model="item.name"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">Description</div>
                                <v-textarea
                                    v-model="item.description"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-textarea>
                            </v-card-text>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">Start Date</div>
                                <v-menu
                                    ref="startDateMenu"
                                    v-model="startDateMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="startDateFormatted"
                                            dense
                                            outlined
                                            persistent-hint
                                            hide-details="auto"
                                            v-bind="attrs"
                                            @blur="
                                                item.start_date = parseDate(
                                                    startDateFormatted
                                                )
                                            "
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="item.start_date"
                                        no-title
                                        @input="startDateMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-card-text>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">End Date</div>
                                <v-menu
                                    ref="endDateMenu"
                                    v-model="endDateMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="endDateFormatted"
                                            dense
                                            outlined
                                            persistent-hint
                                            hide-details="auto"
                                            v-bind="attrs"
                                            @blur="
                                                item.end_date = parseDate(
                                                    endDateFormatted
                                                )
                                            "
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="item.end_date"
                                        no-title
                                        @input="endDateMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-card-text>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">Created At</div>
                                <div class="body-1 my-2">
                                    {{
                                        $moment(item.created_at).format(
                                            "DD-MM-YYYY HH:mm:ss"
                                        )
                                    }}
                                </div>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">Updated At</div>
                                <div class="body-1 my-2">
                                    {{
                                        $moment(item.updated_at).format(
                                            "DD-MM-YYYY HH:mm:ss"
                                        )
                                    }}
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-col>
                <v-col cols="8"> </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    data: (vm) => ({
        modelPath: "feedback-tool/event",
        locations: [],
        item: {
            name: "",
            description: "",
            start_date: null,
            end_date: null,
        },
        startDateMenu: false,
        endDateMenu: false,
        startDateFormatted: vm.formatDate(
            new Date().toISOString().substr(0, 10)
        ),
        endDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    }),
    created() {
        this.getItemDetails().then((data) => {
            this.item = data.item;
        });
        this.getListOfDepartments().then((data) => {
            this.locations = data.items;
        });
    },
    computed: {
        computedStartDateFormatted() {
            return this.formatDate(this.item.start_date);
        },
        computedEndDateFormatted() {
            return this.formatDate(this.item.end_date);
        },
    },
    watch: {
        "item.start_date"(val) {
            this.startDateFormatted = this.formatDate(this.item.start_date);
        },
        "item.end_date"(val) {
            this.endDateFormatted = this.formatDate(this.item.end_date);
        },
    },
    methods: {
        onSave: function () {
            if (this.$refs.editForm.validate()) {
                //TODO :- Perform action if the form is validated

                this.updateItem().then((res) => {
                    if ((res.status = 200)) {
                        this.item = res.item;
                    }
                });
            }
        },
        onDelete: function () {
            this.deleteItem().then((res) => {
                if ((res.status = 204)) {
                    this.$router.push("/feedback-tool/event");
                }
            });
        },
        getItemDetails: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "get",
                    url: `/${this.modelPath}/${this.$route.params.id}`,
                }).then(function (response) {
                    console.log(response.data);
                    let item = response.data;
                    resolve({
                        item,
                    });
                });
            });
        },
        getListOfDepartments: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "get",
                    url: `/locations`,
                })
                    .then(function (response) {
                        console.log(response.data);
                        let items = response.data.results;
                        resolve({
                            items,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
        updateItem: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "put",
                    url: `/${this.modelPath}/${this.$route.params.id}/`,
                    data: this.item,
                }).then(function (response) {
                    console.log(response.data);
                    let status = response.status;
                    let item = response.data;
                    resolve({
                        status,
                        item,
                    });
                });
            });
        },
        deleteItem: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "delete",
                    url: `/${this.modelPath}/${this.$route.params.id}`,
                }).then(function (response) {
                    console.log(response.data);
                    let status = response.status;
                    let item = response.data;
                    resolve({
                        status,
                        item,
                    });
                });
            });
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            var originalDate = this.$moment(date, "DD-MM-YYYY");
            var formattedDate = originalDate.format("YYYY-MM-DD");
            return formattedDate;
        },
    },
};
</script>
